import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { setSounds, soundsOn } from "@/lib/sounds";

/** Turns the site's click and AI chime sounds on or off (remembered on this device). */
export const SoundToggle = ({ className = "" }) => {
  const [on, setOn] = useState(soundsOn());
  const toggle = () => {
    setSounds(!on);
    setOn(!on);
  };
  return (
    <button type="button" onClick={toggle} data-sfx="off" aria-pressed={on} data-testid="sound-toggle"
      className={`inline-flex items-center gap-1.5 hover:underline ${className}`}>
      {on ? <Volume2 className="h-3.5 w-3.5" /> : <VolumeX className="h-3.5 w-3.5" />} Sound effects {on ? "on" : "off"}
    </button>
  );
};
